import React, { useContext, useState } from "react";
import { CommonButton } from "../../components";
import { replySMSService } from "../../services/SMSConversation/index.service";
import { SMSChatContext } from "./SMSChatContext";
import notification from "../../utils/notifications";

const SMSChatMessageFooter = ({ scrollToBottom }) => {
  const { selectedConversation, setMessages, updateConversationPreview } =
    useContext(SMSChatContext);

  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleSend = async () => {
    if (!message.trim() || !selectedConversation?.id) return;

    setIsSending(true);
    try {
      const response = await replySMSService({
        body: {
          conversationId: selectedConversation.id,
          body: message,
        },
      });

      if (response?.success) {
        const newMsg = response.data;
        setMessages((prev) => [newMsg, ...(Array.isArray(prev) ? prev : [])]);
        updateConversationPreview(
          selectedConversation.id,
          newMsg?.body || "",
          newMsg?.createdAt
        );
        setMessage("");
        scrollToBottom?.();
      } else {
        notification({ type: "error", message: "Failed to send message" });
      }
    } catch (error) {
      console.error("Failed to send", error);
      notification({ type: "error", message: "Failed to send message" });
    } finally {
      setIsSending(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSend();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="nk-chat-editor">
      <div className="nk-chat-editor-form">
        <form onSubmit={handleSubmit}>
          <div className="d-flex align-items-center">
            <div className="form-control-wrap w-100">
              <textarea
                className="form-control form-control-simple no-resize bg-white"
                placeholder="Type your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={isSending}
                style={{ whiteSpace: "pre-wrap", minHeight: 44 }}
              />
            </div>

            <ul className="nk-chat-editor-tools g-2">
              <li>
                <CommonButton
                  className="btn btn-round btn-primary btn-icon"
                  type="submit"
                  disabled={isSending}
                >
                  <em className="icon ni ni-send-alt"></em>
                </CommonButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SMSChatMessageFooter;
